import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import {
  VALIDATE_FORM_FIELD,
  VALIDATE_FORM_FIELD_SUCCESS,
  VALIDATE_FORM_FIELD_ERROR
} from "../lib/formsReducer";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { categoryTranslation } from "../app/schema";

export const POST_CATEGORIES_TRANSLATIONS = "POST_CATEGORIES_TRANSLATIONS";
export const POST_CATEGORIES_TRANSLATIONS_SUCCESS = "POST_CATEGORIES_TRANSLATIONS_SUCCESS";
export const POST_CATEGORIES_TRANSLATIONS_ERROR = "POST_CATEGORIES_TRANSLATIONS_ERROR";

export const PATCH_CATEGORY_TRANSLATION = "PATCH_CATEGORY_TRANSLATION";
export const PATCH_CATEGORY_TRANSLATION_SUCCESS = "PATCH_CATEGORY_TRANSLATION_SUCCESS";
export const PATCH_CATEGORY_TRANSLATION_ERROR = "PATCH_CATEGORY_TRANSLATION_ERROR";

export const DELETE_CATEGORY_TRANSLATION = "DELETE_CATEGORY_TRANSLATION";
export const DELETE_CATEGORY_TRANSLATION_SUCCESS = "DELETE_CATEGORY_TRANSLATION_SUCCESS";
export const DELETE_CATEGORY_TRANSLATION_ERROR = "DELETE_CATEGORY_TRANSLATION_ERROR";

// Validation
const validateForm = {
  createCategoryTranslation: (validate, fields, oneField) => validate(
    fields,
    oneField
  )// .prop('name', 'Nazwa').required()
  .getErrors().promise
};

// Requests

const postCategoriesTranslations = (fetch, apiHost, accessToken, data) =>
  fetch(`${apiHost}/v1/categories-translations`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {});
  });

const patchCategoryTranslation = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/categories-translations/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteCategoryTranslation = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/categories-translations/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg: "Nie można usunąć danych tłumaczenia kategorii, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

// Actions

export function createCategoryTranslation(data) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [
      POST_CATEGORIES_TRANSLATIONS,
      POST_CATEGORIES_TRANSLATIONS_SUCCESS,
      POST_CATEGORIES_TRANSLATIONS_ERROR
    ],
    payload: {
      promise: validateForm
        ["createCategoryTranslation"](validate, data)
        .then(() =>
          postCategoriesTranslations(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            data
          ))
        .then(data => {
          return normalize(data, categoryTranslation);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function updateCategoryTranslation(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [
      PATCH_CATEGORY_TRANSLATION,
      PATCH_CATEGORY_TRANSLATION_SUCCESS,
      PATCH_CATEGORY_TRANSLATION_ERROR
    ],
    payload: {
      promise: patchCategoryTranslation(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, categoryTranslation);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeCategoryTranslation(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [
      DELETE_CATEGORY_TRANSLATION,
      DELETE_CATEGORY_TRANSLATION_SUCCESS,
      DELETE_CATEGORY_TRANSLATION_ERROR
    ],
    payload: {
      promise: deleteCategoryTranslation(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

// Standard functions
export function validateFormFieldCategoriesTranslations(form, name, value) {
  const feature = "categoriesTranslations";
  let fields = {};
  fields[name] = value;
  return ({ fetch, validate, config, users }) => ({
    type: [`${VALIDATE_FORM_FIELD}_${feature.toUpperCase()}`],
    payload: {
      promise: validateForm[form](validate, fields, true).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/categoriesTranslations/actions.js